import React from 'react';
import classNames from 'classnames';
import { initializeIcons } from '@fluentui/react';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { computerColor, tabletColor, mobileColor, connectedTVColor } from '../constants/device-color';
import { ComputerIcon } from '../media/computer-icon-svg';
import { TabletIcon } from '../media/tablet-icon-svg';
import { MobileIcon } from '../media/mobile-icon-svg';
import { ConnectedTVIcon } from '../media/connectedTV-icon-svg';
import { getStyles } from '../styles/devices-card';

initializeIcons();
interface LegendProps {
  i18n: {
    getString: (key: string) => string;
  };
}
interface LegendItem {
  title: string;
  color: string;
  icon: any;
}
export const Legend: React.FC<LegendProps> = ({ i18n }) => {
  const styles = useDefaultStyles(getStyles);
  const legends: LegendItem[] = [
    { title: i18n.getString(_TL_('Computer')), color: computerColor, icon: <ComputerIcon color={computerColor} /> },
    { title: i18n.getString(_TL_('Tablet')), color: tabletColor, icon: <TabletIcon color={tabletColor} /> },
    { title: i18n.getString(_TL_('Smartphone')), color: mobileColor, icon: <MobileIcon color={mobileColor} /> },
    { title: i18n.getString(_TL_('CTV')), color: connectedTVColor, icon: <ConnectedTVIcon color={connectedTVColor} /> },
  ];
  const renderLegend = () => (
    <div className={classNames(styles.deviceLegend, 'ba-device-legend')}>
      {legends.map((legend, index) => (
        <div
          key={legend.title}
          className={styles.title}
        >
          <div className={classNames(styles.icon, 'ba-device-legend-icon')}>{legend.icon}</div>
          <span className={classNames('ba-device-legend-title')}>{legend.title}</span>
        </div>
      ))}
    </div>
  );
  return renderLegend();
};
